import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditSecurityProfileButton from './EditSecurityProfileButton';
import DeleteSecurityProfileButton from './DeleteSecurityProfileButton';

const SecurityProfileToolbar = ({ securityProfileId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditSecurityProfileButton securityProfileId={securityProfileId} />{' '}
      <DeleteSecurityProfileButton securityProfileId={securityProfileId} />
    </div>
  </ButtonToolbar>
);

SecurityProfileToolbar.propTypes = {
  securityProfileId: PropTypes.number.isRequired,
};

export default SecurityProfileToolbar;